import L from "leaflet";

L.BoxPattern = L.Pattern.extend({
  options: {
    innerWeight: 4,
    outerWeight: 4,
    innerColor: "#000000",
    outerColor: "#ffffff",
    innerFillColor: "#000000",
    outerFillColor: "#ffffff",
    inneropacity: 1,
    outerOpacity: 1,
    innerFillOpacity: 1,
    outerFillOpacity: 1,
  },
  _addShapes: function () {
    this._outer = new L.PatternPath({
      // stroke: true,
      weight: this.options.outerWeight,
      color: this.options.outerColor,
      fillColor: this.options.outerFillColor,
      opacity: this.options.outerOpacity,
      fillOpacity: this.options.outerFillOpacity,
      fill: true,
    });

    this._inner = new L.PatternPath({
      // stroke: true,
      weight: this.options.innerWeight,
      color: this.options.innerColor,
      fillColor: this.options.innerFillColor,
      opacity: this.options.innerOpacity,
      fillOpacity: this.options.innerFillOpacity,
      fill: true,
    });

    this.addShape(this._outer);
    this.addShape(this._inner);

    this._update();
  },

  _update: function () {
    this._inner.options.d =
      "M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 Z";

    this._outer.options.d = "M 0 0 H 24 V 24 H -100 Z";
  },

  setStyle: L.Pattern.prototype.setStyle,
});

export default L.boxPattern = function (options) {
  return new L.BoxPattern(options);
};
